// Environment configuration utility

// CRM Service URLs
const CRM_BASE_URL_PRODUCTION  = "https://lead-services-827695160227.asia-south1.run.app/api/v1";
const CRM_BASE_URL_DEVELOPMENT = "https://client-glfunnel-service-144135692330.asia-south1.run.app/api/v1";

const isProduction = process.env.REACT_APP_ENVIRONMENT === "production" ||
                     process.env.REACT_APP_GIT_BRANCH === "main";

export const CRM_BASE_URL = isProduction ? CRM_BASE_URL_PRODUCTION : CRM_BASE_URL_DEVELOPMENT;

/**
 * Trigger a push notification to a user by userId.
 * POST /notifications/trigger
 * Body: { userId, title, body }
 */
export const triggerPushNotification = async ({ userId, title, body }) => {
  try {
    await fetch(`${CRM_BASE_URL}/notifications/trigger`, {
      method: "POST",
      headers: { "Content-Type": "application/json" },
      body: JSON.stringify({ userId, title, body }),
    });
  } catch (err) {
    console.error("Push notification failed:", err);
  }
};
export const getCurrentEnvironment = () => {
  // Get environment from build-time environment variable (for S3 deployments)
  // Fallback to git branch detection for local development
  const environment = process.env.REACT_APP_ENVIRONMENT || 
                     (process.env.REACT_APP_GIT_BRANCH === 'main' ? 'production' : 'development');
  
  const currentBranch = process.env.REACT_APP_GIT_BRANCH;
  const isProduction = environment === 'production';
  const isDevelopment = environment === 'development';
  
  return {
    branch: currentBranch,
    environment: environment,
    isProduction,
    isDevelopment,
    configSource: process.env.REACT_APP_ENVIRONMENT ? 'S3 Build' : 'Local Dev'
  };
};

export const getEnvironmentConfig = () => {
  const env = getCurrentEnvironment();
  
  // Determine API URL based on branch, not environment files
  let apiUrl;
  if (env.isProduction) {
    apiUrl = 'https://app-jq4e7ohuqq-uc.a.run.app/api'; // Production API
  } else if (env.isDevelopment) {
    apiUrl = 'https://app-ymyksqua4a-uc.a.run.app/api';  // Development API
  } else {
    apiUrl = 'https://app-ymyksqua4a-uc.a.run.app/api';  // Default to development
  }
  
  const config = {
    ...env,
    apiUrl: process.env.REACT_APP_API_URL || apiUrl,
    debug: env.isDevelopment,
    firebaseProject: env.isProduction 
      ? 'nfbd-scheduler-app' 
      : 'nfbd-scheduler-dev'
  };

  // Enhanced console logging for build-time debugging
  console.log('🚀 ==========================================');
  console.log('🔧 ENVIRONMENT CONFIGURATION LOADED');
  console.log('🚀 ==========================================');
  console.log('📍 Git Branch:', env.branch);
  console.log('🏭 Is Production:', env.isProduction);
  console.log('🧪 Is Development:', env.isDevelopment);
  console.log('🌍 Environment:', env.environment);
  console.log('📡 API URL:', config.apiUrl);
  console.log('🔥 Firebase Project:', config.firebaseProject);
  console.log('🐛 Debug Mode:', config.debug);
  console.log('📦 REACT_APP_API_URL from env:', process.env.REACT_APP_API_URL || 'Not set');
  console.log('🚀 ==========================================');

  return config;
};

// Export environment info for debugging (when file is imported)
console.log('🔧 Environment Utility Loaded - Branch Detection Available');
